import { AuditorWithAuditorCompanyUserAddress } from "api/entities/auditor";
import AuditorEditFormData from "./auditor-edit-form-data";
import { FormValidationDefinition } from "commons/form/useForm";
import formValidationService from "commons/form/form-validation.service";
import auditorEditFormValidationService from "./auditor-edit-form-validation.service";

const createFormData = (responseData: AuditorWithAuditorCompanyUserAddress): AuditorEditFormData => {
  return {
    name: responseData.user.name,
    surname: responseData.user.surname,
    email: responseData.user.email,
    phone: `${responseData.user.phone_prefix}${responseData.user.phone}`,
    login: responseData.user.login,
    originalLogin: responseData.user.login,
    loginCheck: {
      available: true,
      login: responseData.user.login,
    },
    companyId: responseData.user.company_id,
    companyName: responseData.user.company.company_name,
    types: responseData.types,
    addressName: responseData.address.name,
    address: responseData.addr_id,
    password: "",
    passwordConfirm: "",
  };
};

const getEmptyFormData = (): AuditorEditFormData => {
  return {
    name: "",
    surname: "",
    email: "",
    phone: "",
    login: "",
    originalLogin: "",
    loginCheck: {
      available: true,
      login: "",
    },
    companyId: "",
    companyName: "",
    types: [],
    addressName: "",
    address: "",
    password: "",
    passwordConfirm: "",
  };
};

const getFormValidationDefinition = (): FormValidationDefinition<AuditorEditFormData> => {
  return {
    address: formValidationService.ok,
    addressName: formValidationService.ok,
    companyId: formValidationService.ok,
    companyName: formValidationService.ok,
    email: (values) => auditorEditFormValidationService.validateEmail(values.email),
    login: (values) =>
      auditorEditFormValidationService.validateLogin(values.login, values.originalLogin, values.loginCheck),
    originalLogin: formValidationService.ok,
    loginCheck: formValidationService.ok,
    name: (values) => auditorEditFormValidationService.validateName(values.name),
    password: (values) => formValidationService.validatePassword(values.password),
    passwordConfirm: (values) => formValidationService.validatePasswordConfirm(values.password, values.passwordConfirm),
    phone: (values) => auditorEditFormValidationService.validatePhone(values.phone),
    surname: (values) => auditorEditFormValidationService.validateSurname(values.surname),
    types: formValidationService.ok,
  };
};

const auditorEditFormFactory = {
  createFormData,
  getEmptyFormData,
  getFormValidationDefinition,
};

export default auditorEditFormFactory;
